import styled, { css } from 'styled-components';

import { Z_INDEX_SIDE_BAR } from '@savgroup-front-common/constants';
import { rgba } from '@savgroup-front-common/primitive/helpers/cssColor';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';
import { rem } from '@savgroup-front-common/primitive/helpers/units';

import { fontStyle } from '../../../../../../theme/helpers/fontStyle';

export const $Dropdown = styled.ul<{ $menuHeight: number }>`
  position: absolute;
  z-index: ${Z_INDEX_SIDE_BAR};
  bottom: ${({ $menuHeight }) => rem(-1 * $menuHeight - 10)};
  left: 0;
  display: flex;
  width: 300px;
  max-height: 200px;
  flex-direction: column;
  padding: 1px 0;
  margin: 0;
  color: ${({ theme }) => theme.colors.mainTextColor};
  list-style: none;
  overflow-y: scroll;
  outline: none;
  border: 1px solid ${({ theme }) => theme.colors.default};

  background: ${({ theme }) => theme.systemColors.defaultBackground};
  border-radius: ${({ theme }) => theme.tw.radius.sm};
`;

export const $PreferredDivider = styled.hr`
  height: ${spacing('px')};
  border: none;
  margin: 0;
  background: gainsboro;
`;

export const $Flag = styled.span`
  display: inline-flex;
  align-items: center;
  margin-right: ${spacing('sm')};
`;

export const $ListItem = styled.li<{
  $selected?: boolean;
  $focused?: boolean;
  $preferred?: boolean;
}>`
  display: flex;
  min-height: ${spacing(7)};
  box-sizing: border-box;
  align-items: center;
  cursor: pointer;

  padding: ${spacing(2.5)} 1rem;

  &:hover {
    background-color: ${({ theme }) => rgba(theme.colors.primary, 0.05)};
    color: ${({ theme }) => theme.colors.primary};
    cursor: pointer;
    border: none;
  }

  ${({ $selected }) =>
    $selected
      ? css`
          background-color: ${({ theme }) => rgba(theme.colors.primary, 0.05)};
          color: ${({ theme }) => theme.colors.primary};
          cursor: pointer;
          border: none;
        `
      : ''}

  ${({ $focused, $selected }) =>
    $focused && !$selected
      ? css`
          background-color: ${({ theme }) => rgba(theme.colors.primary, 0.05)};
        `
      : ''}
`;

export const $CountryName = styled.span`
  overflow: hidden;
  margin-right: ${spacing('sm')};
  ${fontStyle('sm')};
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const $DialCode = styled.span<{ $selected?: boolean }>`
  ${fontStyle('sm')};
  color: ${({ $selected, theme }) =>
    $selected
      ? theme.colors.paragraphTextColor
      : theme.colors.paragraphTextColor};
`;
